import { render, staticRenderFns } from "./addNewTimeOfDayDialog.vue?vue&type=template&id=10e70b27&"
import script from "./addNewTimeOfDayDialog.vue?vue&type=script&lang=js&"
export * from "./addNewTimeOfDayDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports